module.exports = __webpack_public_path__ + "media/images/emblems/Sorvilier-coat_of_arms-73f956c32ef85e55ab7bf8929a90f054.svg";